module.exports = __webpack_public_path__ + "static/media/how-we-might-build-a-food-utopia.590a75d9.jpg";